import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import * as authAction from '../../actions/authAction';
import { isEmpty, capitalize, groupBy, map, uniqBy, } from 'lodash';
import { getDateFormat } from '../../utils/helpers';
import AuthService from '../../services/authService';
import * as LoaderAction from '../../actions/loaderAction';
import Notification from '../../utils/notification';
import moment from 'moment';
import DialysisPrint from '../../components/DialysisPrint';
import ReactDOMServer from 'react-dom/server';
import ReactDOM from 'react-dom';


class DialysisDetail extends React.Component {
    constructor(props) {
        super(props);
        const patientId = this.props.match.params.patientId;
        const id = this.props.match.params.id;
        this.state = {
            patientId:patientId,
            id:id,
            patient: {},
            provider:{},
            date: "",
            machine_room_no: "",
            duration_hrs: "",
            time_on: "",
            time_off: "",
            is_permanent: false,
            is_transient: false,
            medication_orders: "",
            pre_dialysis_evaluation: "",
            dry_weight: "",
            infusion_rinse: "",
            infusion_drink: "",
            infusion_blood: "",
            est_weight_loss_ml: "",
            total_weight_loss_ml: "",
            target_weight_loss_kg: "",
            heparin_bolus: "",
            hourly_rate: "",
            blood_flow_rate: "",
            dialyzer: "",
            dialysate_flow: "",
            access: "",
            program_na_modelling: "",
            bruit:"",
            prev_weight: "",
            prev_bp: "",
            prev_pulse: "",
            prev_temp:"",
            pre_weight: "",
            pre_bp: "",
            pre_pulse: "",
            pre_temp: "",
            post_weight: "",
            post_bp: "",
            post_pulse: "",
            post_temp: "",
            comments:"",
            dialysisData: [
                {
                    recorded_time: '',
                    pulse: '',
                    bp: '',
                    blood_flow: '',
                    art_press: '',
                    venous_press: '',
                    temperature: '',
                    dialysate_flow: '',
                    conductivity: '',
                    fluid_loss: '',
                    heparin: ''
                }
            ],
            address:{},
        }
    }

    componentDidMount() {
        this.props.showLoader();
        AuthService.getPatientById(this.state.patientId).then(response => {
            let { data } = response;
            this.setState({
                patient: data
            });
            this.props.hideLoader();
        }).catch(error => {
            this.props.hideLoader();
            Notification.show('error', error.response.data)
        });

        AuthService.getDialysisDetail(this.state.patientId,this.state.id).then(response => {
            let dialysis = response.data;
            let dialysisRecord = dialysis.data[0];
            let patient_info = {};
            try {
                patient_info = JSON.parse(dialysisRecord.patient_info);
            } catch (e) {
                console.error('Invalid JSON in patient_info:', e);
            }

            let provider_info = {};
            try {
                provider_info = JSON.parse(dialysisRecord.service_provider_info);
            } catch (e) {
                console.error('Invalid JSON in provider_info:', e);
            }
            
            this.setState({
                patient: patient_info,
                provider: provider_info,
                machine_room_no: dialysisRecord.machine_room_no || "",
                date: dialysisRecord.date || "",
                duration_hrs: dialysisRecord.duration_hrs || "",
                time_on: dialysisRecord.time_on || "",
                time_off: dialysisRecord.time_off || "",
                is_permanent: dialysisRecord.is_permanent || false,
                is_transient: dialysisRecord.is_transient || false,
                medication_orders: dialysisRecord.medication_orders || "",
                pre_dialysis_evaluation: dialysisRecord.pre_dialysis_evaluation || "",
                dry_weight: dialysisRecord.dry_weight || "",
                infusion_rinse: dialysisRecord.infusion_rinse || "",
                infusion_drink: dialysisRecord.infusion_drink || "",
                infusion_blood: dialysisRecord.infusion_blood || "",
                est_weight_loss_ml: dialysisRecord.est_weight_loss_ml || "",
                total_weight_loss_ml: dialysisRecord.total_weight_loss_ml || "",
                target_weight_loss_kg: dialysisRecord.target_weight_loss_kg || "",
                heparin_bolus: dialysisRecord.heparin_bolus || "",
                hourly_rate: dialysisRecord.hourly_rate || "",
                blood_flow_rate: dialysisRecord.blood_flow_rate || "",
                dialyzer: dialysisRecord.dialyzer || "",
                dialysate_flow: dialysisRecord.dialysate_flow || "",
                access: dialysisRecord.access || "",
                program_na_modelling: dialysisRecord.program_na_modelling || "",
                bruit: dialysisRecord.bruit || "",
                prev_weight: dialysisRecord.prev_weight || "",
                prev_bp: dialysisRecord.prev_bp || "",
                prev_pulse: dialysisRecord.prev_pulse || "",
                prev_temp: dialysisRecord.prev_temp || "",
                pre_weight: dialysisRecord.pre_weight || "",
                pre_bp: dialysisRecord.pre_bp || "",
                pre_pulse: dialysisRecord.pre_pulse || "",
                pre_temp: dialysisRecord.pre_temp || "",
                post_weight: dialysisRecord.post_weight || "",
                post_bp: dialysisRecord.post_bp || "",
                post_pulse: dialysisRecord.post_pulse || "",
                post_temp: dialysisRecord.post_temp || "",
                comments: dialysisRecord.comments || "",
                address: dialysisRecord.user_location || "",
                dialysisData: (dialysisRecord.dialysis_data && dialysisRecord.dialysis_data.length > 0)
                ? dialysisRecord.dialysis_data
                : this.state.dialysisData

            });
            this.props.hideLoader();
        }).catch(error => {
            this.props.hideLoader();
            Notification.show('error', error.response.data)
        });

    }

    calculateAge = (dob) => {
        if (!dob) return null;
        const birth = moment(dob);
        const now = moment();
        const years = now.diff(birth, 'years');
        const months = now.diff(birth.clone().add(years, 'years'), 'months');
        return { years, months };
    }

    printReport = () => {
        const container = document.getElementById('print-area');
        ReactDOM.render(<DialysisPrint data={this.state} />, container, () => {
            const printContents = container.innerHTML;
    
            // Open a print document
            const printFrame = document.createElement('iframe');
            printFrame.style.position = 'fixed';
            printFrame.style.right = '0';
            printFrame.style.bottom = '0';
            printFrame.style.width = '0';
            printFrame.style.height = '0';
            printFrame.style.border = '0';
            document.body.appendChild(printFrame);
    
            const frameDoc = printFrame.contentWindow || printFrame.contentDocument;
            const doc = frameDoc.document || frameDoc;
    
            doc.open();
            doc.write(`
                <html>
                    <head>
                        <title></title>
                        <style>
                        @page {
                            size: A3 portrait;
                            margin: 0;
                        }

                        @media print {
                            body {
                                margin: 0;
                                padding: 10mm;
                                font-family: Arial, sans-serif;
                            }

                            table {
                                width: 100%;
                                border-collapse: collapse;
                            }

                            th, td {
                                border: 1px solid black;
                                padding: 5px;
                                text-align: center;
                            }
                        }

                        body {
                            font-family: Arial, sans-serif;
                        }
                    </style>
                    </head>
                    <body>
                        ${printContents}
                    </body>
                </html>
            `);
            doc.close();
    
            // Wait for content to render, then print
            printFrame.onload = () => {
                frameDoc.focus();
                frameDoc.print();
                setTimeout(() => {
                    document.body.removeChild(printFrame); // Clean up
                }, 1000);
            };
        });
    };
    

    render() {
        return (<React.Fragment>
            <Helmet>
                <title>Dialysis</title>
            </Helmet>
            <style>
                {`
                    .btn-custom {
                        min-width: 150px !important;
                        margin: 5px;
                        margin-top: 17px;
                        height: 38px;
                    }
                    .table-custom-td{
                        border-top: none !important;
                        border-bottom: none !important;
                        color: inherit !important;
                        width: 140px;
                    }
                    .table-custom-th{
                        border-bottom: none !important;
                        vertical-align: top !important;
                        width: 200px;
                    }
                    .table-fontCss{
                        font-weight: bold;
                    }
                    .content-wrapper h6 {
                        font-weight: bold;
                    }
                `}
            </style>

            <div id="print-area" style={{ display: 'none' }}></div>
            <section className="middle-wrapper v-center">
                <div className="container">
                    <div className="list-header">
                        <Link to={"/patients/" + this.state.patientId + "/prescriptions"} className="white-bg"><span>&#8249;</span> Dialysis </Link>
                        <span className="date"> <button className="btn btn-primary btn-custom" onClick={this.printReport}>Print</button></span>
                    </div>
                    <section>
                    <div className="prescription-list">
                            <div className="content-wrapper">
                                <h6>Patient Info</h6>
                                <ul className="details-listing">
                                    <li>Name: <span>{this.state.patient.full_name}</span></li>
                                    {this.state.patient.date_of_birth &&
                                        (() => {
                                            const age = this.calculateAge(this.state.patient.date_of_birth);
                                            return (
                                                <li>Date of Birth: <span>{age.years} year{age.years !== 1 ? 's' : ''}  {age.months} month{age.months !== 1 ? 's' : ''}</span></li>
                                            );
                                        })()
                                    }
                                    <li>Gender: <span>{capitalize(this.state.patient.gender)}</span></li>
                                </ul>
                                <h6></h6>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <td className="table-custom-td">Machine/Room No.:</td>
                                                <th className="table-custom-th">{this.state.machine_room_no}</th>
                                                <td className="table-custom-td">Duration (hrs):</td>
                                                <th className="table-custom-th">{this.state.duration_hrs}</th>
                                                <td className="table-custom-td">Permanent:</td>
                                                <th className="table-custom-th">{this.state.is_permanent ? 'Yes' : 'No'}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Transient:</td>
                                                <th className="table-custom-th">{this.state.is_transient ? 'Yes' : 'No'}</th>
                                                <td className="table-custom-td">Date:</td>
                                                <th className="table-custom-th">{this.state.date ? moment(this.state.date).format('YYYY-MM-DD') : ''}</th>
                                                <td className="table-custom-td">Time on:</td>
                                                <th className="table-custom-th">{capitalize(this.state.time_on)}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Time off:</td>
                                                <th className="table-custom-th">{capitalize(this.state.time_off)}</th>
                                                <td className="table-custom-td">Medication Orders and Administration:</td>
                                                <th className="table-custom-th">{capitalize(this.state.medication_orders)}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>

                            <div className="content-wrapper">
                                <h6>Pre-Dialysis Information/Instructions</h6>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <td className="table-custom-td">Pre-Dialysis Evalution:</td>
                                                <th className="table-custom-th">{this.state.pre_dialysis_evaluation}</th>
                                                <td className="table-custom-td">Dry Weight:</td>
                                                <th className="table-custom-th">{this.state.dry_weight}</th>
                                                <td className="table-custom-td">Infusion Rinse:</td>
                                                <th className="table-custom-th">{this.state.infusion_rinse}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Infusion Drink:</td>
                                                <th className="table-custom-th">{this.state.infusion_drink}</th>
                                                <td className="table-custom-td">Infusion Blood:</td>
                                                <th className="table-custom-th">{this.state.infusion_blood}</th>
                                                <td className="table-custom-td">Est. weight loss (ml):</td>
                                                <th className="table-custom-th">{this.state.est_weight_loss_ml}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Total weight loss (ml):</td>
                                                <th className="table-custom-th">{this.state.total_weight_loss_ml}</th>
                                                <td className="table-custom-td">Target weight loss(kg):</td>
                                                <th className="table-custom-th">{this.state.target_weight_loss_kg}</th>
                                                <td className="table-custom-td">Heparin - Bolus:</td>
                                                <th className="table-custom-th">{this.state.heparin_bolus}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Dialyzer:</td>
                                                <th className="table-custom-th">{this.state.dialyzer}</th>
                                                <td className="table-custom-td">Hourly-rate:</td>
                                                <th className="table-custom-th">{this.state.hourly_rate}</th>
                                                <td className="table-custom-td">Blood Flow Rate:</td>
                                                <th className="table-custom-th">{this.state.blood_flow_rate}</th>
                                            </tr>
                                            <tr>
                                                <td className="table-custom-td">Access:</td>
                                                <th className="table-custom-th">{this.state.access}</th>
                                                <td className="table-custom-td">Program Na+ Modelling:</td>
                                                <th className="table-custom-th">{this.state.program_na_modelling}</th>
                                                <td className="table-custom-td">Bruit:</td>
                                                <th className="table-custom-th">{capitalize(this.state.bruit)}</th>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>

                            <div className="content-wrapper">
                                <h6></h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Parameters</th>
                                                <th>Previous Discharge</th>
                                                <th>Pre Dialysis</th>
                                                <th>Post Dialysis</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="table-fontCss">Weight (kg)</td>
                                                <td>{this.state.prev_weight}</td>
                                                <td>{this.state.pre_weight}</td>
                                                <td>{this.state.post_weight}</td>
                                            </tr>
                                            <tr>
                                                <td className="table-fontCss">Blood Pressure(mm/Hg)</td>
                                                <td>{this.state.prev_bp}</td>
                                                <td>{this.state.pre_bp}</td>
                                                <td>{this.state.pre_bp}</td>
                                            </tr>
                                            <tr>
                                                <td className="table-fontCss">Pulse</td>
                                                <td>{this.state.prev_pulse}</td>
                                                <td>{this.state.pre_pulse}</td>
                                                <td>{this.state.post_pulse}</td>
                                            </tr>
                                            <tr>
                                            <td className="table-fontCss">Temperature(C)</td>
                                                <td>{this.state.prev_temp}</td>
                                                <td>{this.state.pre_temp}</td>
                                                <td>{this.state.post_temp}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>


                            <div className="content-wrapper">
                                <h6>Dialysis Data Records</h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Recorded Time</th>
                                                <th>Pulse</th>
                                                <th>BP</th>
                                                <th>Blood Flow</th>
                                                <th>Art. Pressure</th>
                                                <th>Venous Pressure</th>
                                                <th>Temperature</th>
                                                <th>Dialysate Flow</th>
                                                <th>Conductivity</th>
                                                <th>Fluid Loss</th>
                                                <th>Heparin</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.dialysisData.map((data, index) => (
                                                <tr key={index}>
                                                    <td>{data.recorded_time ? moment(data.recorded_time).format('YYYY-MM-DD HH:mm') : '-'}</td>
                                                    <td>{data.pulse}</td>
                                                    <td>{data.bp}</td>
                                                    <td>{data.blood_flow}</td>
                                                    <td>{data.art_press}</td>
                                                    <td>{data.venous_press}</td>
                                                    <td>{data.temperature}</td>
                                                    <td>{data.dialysate_flow}</td>
                                                    <td>{data.conductivity}</td>
                                                    <td>{data.fluid_loss}</td>
                                                    <td>{data.heparin}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="content-wrapper">
                                <h6>Comments</h6>
                                <ul className="details-listing">
                                    <li> <span>{this.state.comments}</span></li>                       
                                </ul>                               
                            </div>

                        </div>                      
                    </section>
                </div>
            </section>
        </React.Fragment>);
    }
}

const mapStateToProps = (state) => ({
    user: state.session.user,
    authenticated: state.session.authenticated,
});

const mapActionsToProps = ({
    hideLoader: LoaderAction.loaderHide,
    showLoader: LoaderAction.loaderShow,
})

export default connect(mapStateToProps, mapActionsToProps)(DialysisDetail);
